import React from 'react';
import Router from './router';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

import theme from '@/styles/theme';
import { ThemeProvider } from '@/styles/theme-components';

import AppLayoutComponent from './components/AppLayout';
import GlobalStyle from '@/styles/GlobalStyle';
import GlobalAlert from '@/components/GlobalAlert';
import './styles/global.css';
import GlobalAlertPrescriptionModified from '@/components/AlertPrescriptionModifiedModal/GlobalAlertPrescriptionModified';
import AuthGuard from '@/components/auth/AuthGuard';
import '@material-symbols/font-400/rounded.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

const App = () => {
  return (
    <RecoilRoot>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <GlobalStyle />
          <ThemeProvider theme={theme}>
            <GlobalAlert ref={GlobalAlert.setRef} />
            <GlobalAlertPrescriptionModified
              ref={GlobalAlertPrescriptionModified.setRef}
            />
            <AppLayoutComponent>
              <AuthGuard>
                <Router />
              </AuthGuard>
            </AppLayoutComponent>
          </ThemeProvider>
        </BrowserRouter>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </RecoilRoot>
  );
};

export default App;
